const icons = [];
const modules = import.meta.glob('./../../assets/icons/svg/*.svg');
const customModules = import.meta.glob('./../../assets/icons/png/*.png');
for (const path in modules) {
  if (modules.hasOwnProperty.call(modules, path)) {
    const p = path.split('assets/icons/svg/')[1].split('.svg')[0];
    icons.push(p);
  }
}

export default icons;
